"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
function calculateValue(value) {
    return value;
}
var SliderContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 6px;\n  background: #e0e0e0;\n  border-radius: 5px;\n  margin: 20px 0;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 6px;\n  background: #e0e0e0;\n  border-radius: 5px;\n  margin: 20px 0;\n"])));
var SliderTrack = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  height: 100%;\n  background: #3f51b5;\n  border-radius: 5px;\n  width: ", "%;\n"], ["\n  position: absolute;\n  height: 100%;\n  background: #3f51b5;\n  border-radius: 5px;\n  width: ", "%;\n"])), function (props) { return props.width; });
var SliderThumb = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: -5px;\n  width: 16px;\n  height: 16px;\n  background: #3f51b5;\n  border-radius: 50%;\n  cursor: pointer;\n  left: ", "%;\n  transform: translateX(-50%);\n"], ["\n  position: absolute;\n  top: -5px;\n  width: 16px;\n  height: 16px;\n  background: #3f51b5;\n  border-radius: 50%;\n  cursor: pointer;\n  left: ", "%;\n  transform: translateX(-50%);\n"])), function (props) { return props.left; });
// Slider component
var Slider = function (_a) {
    var min = _a.min, max = _a.max, value = _a.value, onChange = _a.onChange, _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, react_1.useState)(false), isDragging = _c[0], setIsDragging = _c[1];
    var handleMouseDown = function () {
        setIsDragging(true);
    };
    var handleMouseUp = function () {
        setIsDragging(false);
    };
    var handleMouseMove = (0, react_1.useCallback)(function (e) {
        if (isDragging) {
            var sliderRect = e.target.getBoundingClientRect();
            var newValue = Math.min(max, Math.max(min, min + ((e.clientX - sliderRect.left) / sliderRect.width) * (max - min)));
            onChange(newValue);
        }
    }, [isDragging, max, min, onChange]);
    (0, react_1.useEffect)(function () {
        if (isDragging) {
            window.addEventListener("mousemove", handleMouseMove);
            window.addEventListener("mouseup", handleMouseUp);
        }
        else {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        }
        return function () {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseup", handleMouseUp);
        };
    }, [isDragging, handleMouseMove]);
    var valuePercentage = ((value - min) / (max - min)) * 100;
    return ((0, jsx_runtime_1.jsxs)(SliderContainer, __assign({ className: "twap-slider ".concat(className), onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp }, { children: [(0, jsx_runtime_1.jsx)(SliderTrack, { width: valuePercentage }), (0, jsx_runtime_1.jsx)(SliderThumb, { left: valuePercentage })] })));
};
exports.Slider = Slider;
var templateObject_1, templateObject_2, templateObject_3;
